import {
    VuexModule,
    Module,
    Mutation,
    Action,
    getModule
} from "vuex-module-decorators";
import store from "@/store";
import { getCommunityHistory, getCommunityHistoryByDate } from '@/api/placeService';
import { getDefaultPagination, getPagination } from '@/utils/store-util';
import { Entity } from '@/types';
import { CommunityType, PlaceOptions } from '@/types/place';
import { Rounding } from '@/utils/app-util';
import lodash from 'lodash';

export interface CommunityHistoryState {
    pagination: Pagination;
    loading: boolean;
    loadingTab2: boolean;
    itemsTab2: CommunityType[];
    totalRecords: number;
    items: CommunityType[];
}

@Module({ store, dynamic: true, name: 'communityHistoryModule' })
class CommunityHistoryModule extends VuexModule implements CommunityHistoryState {
  public pagination = getDefaultPagination();
  public loading = false;
  public totalRecords = 0;
  public items: CommunityType[] = [];
  public itemsTab2: CommunityType[] = [];
  public loadingTab2 = false;
  public totalPages = 0;
  public currentPage = 1;

  @Action({ rawError: true }) async getPlace(options: PlaceOptions): Promise<TODO> {
    await this.clearPlace();
    this.setLoading(true);
    const data = lodash.cloneDeep(await getCommunityHistory(options));
    this.setTotalRecords(data.total_records);
    this.setTotalPages(data.total_page);
    this.setCurrentPage(options.page);
    await this.formateRecords({ data: data.records, formatTime:  false});
    await this.setDataTable(data.records);
    this.setLoading(false);
  }

  @Action({rawError: true}) async getPlaceByDate(date: string): Promise<TODO>{
    await this.clearPlaceTab2();
    this.setLoadingTab2(true);
    const data = lodash.cloneDeep(await getCommunityHistoryByDate(date));
    
    await data.forEach((element)=>{
      if (element){
        element.bp_red = (element.bp_red || 0) + (element.bp_yellow || 0);
        element.grip_red = (element.grip_red || 0) + (element.grip_yellow || 0);
        element.frailty_red = (element.frailty_red || 0) + (element.frailty_yellow || 0);
        element.bmi_red = (element.bmi_red || 0) + (element.bmi_yellow || 0);
        for (const key of Object.keys(element)) {
          if (key.endsWith('_avg') && element[key] !== null) {
            element[key] = Rounding(element[key], 2);
          }
        }
      }
    });
    console.log(data);
    await this.setItemTab2(data);
    this.setLoadingTab2(false);
  }

  @Action({ rawError: true }) async formateRecords(obj: { data, formatTime: boolean }) {

    await obj.data.sort((a, b) => {
      return new Date(a.measure_at).getTime() > new Date(b.measure_at).getTime()
        ? 1
        : new Date(b.measure_at).getTime() > new Date(a.measure_at).getTime()
          ? -1
          : 0;
    });
    await obj.data.forEach((element) => {
      if (element) {
        if (!obj.formatTime) {
          element.measure_at = new Date(
            element.measure_at * 1000
          ).toISOString().split('T')[0];
          element.data.bp_red = (element.data.bp_red || 0) + (element.data.bp_yellow || 0);
          element.data.grip_red = (element.data.grip_red || 0) + (element.data.grip_yellow || 0);
          element.data.frailty_red = (element.data.frailty_red || 0) + (element.data.frailty_yellow || 0);
          element.data.bmi_red = (element.data.bmi_red || 0) + (element.data.bmi_yellow || 0);
          for (const key of Object.keys(element.data)) {
            if (key.endsWith('_avg') && element.data[key] !== null) {
              element.data[key] = Rounding(element.data[key], 2);
            }
          }
        }
      }
    });
    this.setItem(obj.data)
  }

  @Action({ rawError: true }) async clearPlace() {
    this.setItem([]);
    this.setTotalPages(0);
    this.setTotalRecords(0);
    this.setPagination(getDefaultPagination());
  }
  @Action({ rawError: true }) async clearPlaceTab2() {
    this.setItemTab2([]);
  }
  @Action({ rawError: true }) setDataTable(data: Entity[]) {
    const pagination = getPagination(data, this.totalPages, this.currentPage);
    this.setPagination(pagination);
  }
  @Mutation setPagination(pagination: TODO): void {
    this.pagination = pagination;
  }
  @Mutation setLoading(loading: boolean): void {
    this.loading = loading;
  }
  @Mutation setLoadingTab2(loadingTab2: boolean): void {
    this.loadingTab2 = loadingTab2;
  }
  @Mutation setTotalRecords(totalRecords: number): void {
    this.totalRecords = totalRecords;
  }

  @Mutation setTotalPages(totalPages: number): void {
    this.totalPages = totalPages;
  }
  @Mutation setCurrentPage(page: number): void {
    this.currentPage = page;
  }
  @Mutation setItem(items: CommunityType[]): void {
    this.items = lodash.cloneDeep(items);
  }
  @Mutation setItemTab2(itemsTab2: CommunityType[]): void {
    this.itemsTab2 = lodash.cloneDeep(itemsTab2);
  }
}
export const communityHistoryModule = getModule(CommunityHistoryModule);